import React from 'react'

const MisDeposit = () => {
    const dailyLoanFeatures: string[] = [
        'Frequent Repayment: Borrowers must make payments every day, typically from the business’s daily earnings or personal income.',
        'Short-Term Financing: Daily loans usually have shorter repayment periods, often ranging from a few weeks to several months.',
        'Higher Interest Rates: Due to their short-term nature and the convenience of quick access to funds, daily loans often come with higher interest rates compared to traditional loans.',
        'Automatic Deductions: Repayments are often automatically deducted from the borrower’s account daily, ensuring consistent payments.',
        'Flexible Use: Funds from daily loans can be used for various purposes, including covering business expenses, purchasing inventory, or handling unexpected costs.'
    ];

    const dailyLoanEligibility: string[] = [
        'Small businesses with steady daily cash flow',
        'Entrepreneurs needing immediate cash for short-term business opportunities or emergencies',
        'Individuals seeking short-term loans with quick repayment cycles'
    ];

    const tableData = [
        {
            rs: '10000000',
            60: '83333',
            84: '87500',
            120: '91667'
        },
        {
            rs: '5000000',
            60: '41667',
            84: '43750',
            120: '45833'
        },
        {
            rs: '2500000',
            60: '20833',
            84: '21875',
            120: '22917'
        },
        {
            rs: '1000000',
            60: '8333',
            84: '8750',
            120: '9167'
        },
        {
            rs: '500000',
            60: '4167',
            84: '4375',
            120: '4583'
        },
        {
            rs: '200000',
            60: '1667',
            84: '1750',
            120: '1833'
        },
        {
            rs: '100000',
            60: '833',
            84: '875',
            120: '917'
        },

    ]
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    What is an Daily Loan?
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A daily loan is a type of short-term financing where the borrower is required to make repayments on a daily basis rather than monthly or weekly. These loans are typically designed for small businesses or individuals who need quick access to cash and can repay the loan with frequent, smaller installments. Daily loans are often used to manage working capital, cover operational costs, or handle emergencies.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Key Features of a Daily Loan:
                </h2>
                {dailyLoanFeatures.map((point, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                        <span className="text-md text-gray-600">{point}</span>
                    </div>
                ))}
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Ideal For:
                </h2>
                {dailyLoanEligibility.map((point, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                        <span className="text-md text-gray-600">{point}</span>
                    </div>
                ))}
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Feature Of MIS:
                </h2>
                <div className='border'>
                    <div className='flex flex-row'>
                        <div style={{ flex: 1 }} className='bg-blue-600 border flex items-center justify-center'>
                            <p className='font-bold text-white text-md text-center'>Depoit Amount <br /> (In Rs.)</p>
                        </div>
                        <div style={{ flex: 3 }} className='bg-blue-600 border'>
                            <div className='flex'>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>60 Months</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>84 Months</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center '>120 Months</p>
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>10%</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>10.50%</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center '>11%</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        tableData.map((item) => (
                            <div className='flex '>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium  text-md text-center'>{item.rs}</p>
                                </div>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium text-md text-center'>{item[60]}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item[84]}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item[120]}</p>
                                </div>
                            </div>
                        ))
                    }

                </div>

            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Pre Closure Conditions: (Monthly Income Scheme)
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    If the customer opting for pre-closure of the fixed deposit before expiry, the interest will be revised to the corresponding interest rate fixed for the period where the date of the pre-closure date falls. An additional 2% will be deducted from this rate as a penalty.                </p>
            </div>
        </div>
    )
}

export default MisDeposit
